import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import MediaSection from '@/pages/home/components/MediaSection';
import AppSection from '@/pages/home/components/AppSection';
import FaqSection from '@/pages/home/components/FaqSection';
import IndexSection from '@/pages/home/components/IndexSection';
import CardsSection from '@/pages/home/components/CardsSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import RankingSection from '@/pages/home/components/RankingSection';
import ContactSection from '@/pages/home/components/ContactSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import TopicsSection from '@/pages/home/components/TopicsSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <MediaSection />
        <AppSection />
        <FaqSection />
        <IndexSection />
        <CardsSection />
        <CarouselSection />
        <FeaturesSection />
        <UpdatesSection />
        <RankingSection />
        <ContactSection />
        <AboutSection />
        <CommentsSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}